import React from "react";
import { Link } from "react-router-dom";
import { Car, Facebook, Instagram, Phone, Mail, MapPin, Clock } from "lucide-react";
import { useT } from "../i18n";
import { useSettings } from "../lib/useSettings";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}><path d="M16.6 5.82s.51.5 0 0A4.278 4.278 0 0 1 15.54 3h-3.09v12.4a2.592 2.592 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6 0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64 0 3.33 2.76 5.7 5.69 5.7 3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.34-1.48z"/></svg>
);

export const Footer = () => {
  const { t } = useT();
  const s = useSettings();
  const brand = s.company_name || "ClickRent";

  return (
    <footer className="bg-black text-white mt-auto">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="bg-white text-black p-1.5 rounded-md"><Car className="h-5 w-5" /></div>
            <span className="font-heading font-extrabold text-lg">{brand}</span>
          </div>
          <p className="text-sm text-white/60 leading-relaxed">{s.tagline}</p>
          <div className="flex gap-3 mt-5">
            {s.facebook && <a href={s.facebook} target="_blank" rel="noreferrer" className="p-2 bg-white/10 rounded-md hover:bg-accent transition-colors" data-testid="footer-facebook"><Facebook className="h-4 w-4" /></a>}
            {s.instagram && <a href={s.instagram} target="_blank" rel="noreferrer" className="p-2 bg-white/10 rounded-md hover:bg-accent transition-colors" data-testid="footer-instagram"><Instagram className="h-4 w-4" /></a>}
            {s.tiktok && <a href={s.tiktok} target="_blank" rel="noreferrer" className="p-2 bg-white/10 rounded-md hover:bg-accent transition-colors" data-testid="footer-tiktok"><TikTokIcon className="h-4 w-4" /></a>}
          </div>
        </div>

        <div>
          <h4 className="font-heading font-semibold mb-4 text-sm uppercase tracking-wider">{t("footer.quick")}</h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li><Link to="/fleet" className="hover:text-white transition-colors">{t("nav.fleet")}</Link></li>
            <li><Link to="/about" className="hover:text-white transition-colors">{t("nav.about")}</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">{t("nav.contact")}</Link></li>
            <li><Link to="/legal/terms" className="hover:text-white transition-colors">{t("footer.terms")}</Link></li>
          </ul>
          <h4 className="font-heading font-semibold mt-6 mb-3 text-sm uppercase tracking-wider">{t("footer.legal")}</h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li><a href="https://anpc.ro/" target="_blank" rel="noreferrer" className="hover:text-white transition-colors" data-testid="footer-anpc">ANPC</a></li>
            <li><a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer" className="hover:text-white transition-colors" data-testid="footer-sol">SOL (Soluționare Online Litigii)</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold mb-4 text-sm uppercase tracking-wider">{t("footer.contact")}</h4>
          <ul className="space-y-3 text-sm text-white/60">
            {s.phone && <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-accent" /> {s.phone}</li>}
            {s.email && <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-accent" /> {s.email}</li>}
            {s.address && <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-accent" /> {s.address}</li>}
            {s.program && <li className="flex items-center gap-2"><Clock className="h-4 w-4 text-accent" /> {s.program}</li>}
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold mb-4 text-sm uppercase tracking-wider">{t("footer.company_info")}</h4>
          <ul className="space-y-1.5 text-sm text-white/60">
            <li>{brand}</li>
            {s.cui && <li>CUI: {s.cui}</li>}
            {s.reg_com && <li>Reg. Com.: {s.reg_com}</li>}
            {s.sediu_social && <li>{s.sediu_social}</li>}
          </ul>
          <p className="text-xs text-white/40 mt-4 leading-relaxed">{t("footer.wa_note")}</p>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/40">
        © {new Date().getFullYear()} {brand}. {t("footer.rights")}
      </div>
    </footer>
  );
};
